import { ChangeEvent, useCallback, useMemo, useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { BRDiv } from "src/components/common/common";
import SearchInput from "src/components/common/form/input/SearchInput";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { defaultPRD3010_R01Filter, usePRD3010_R01Store } from "./Store_PRD3010_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { ItemDto } from "src/types/base";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { getUserBySearch } from "src/apis/authApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { getEmployeeList } from "src/apis/employeeApi";
import LabelPrintButton from "src/components/common/LabelPrintButton";
import { LabelPrintData } from "src/apis/labelApi";

interface Props {
    onEnterKeyDown: () => void;
}

export const SearchSection_PRD3010_R01 = ({ 
	onEnterKeyDown,
}: Props) => {

	const { PRD3010_R01Filter, setPRD3010_R01Filter, selectedPRD3010_R01LotList, PRD3010_R01LotList } = usePRD3010_R01Store();
	const { compCdList } = useCommonCodeStore();

    const { setCodeSearchModalProps } = useUiuxStore();

	const { yesNoList, devStsList, workPlaceList } = useCommonCodeStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPos, setPickerPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const productEmpInfoHandleFoucsId = 'infoProductEmpInput_search';

	
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
            category: "품목",
            focusId: "itemCd_search",
			responseMapping: {
				itemCd : 'itemCd',
				itemNm : 'itemNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getItemPopupList(code, '', '', '');
				return employeeResponse.data.data.find(value => value.itemCd === code);
			}
        },
		{
			fieldName: 'workEmp',
			category: '담당자',
			focusId: productEmpInfoHandleFoucsId,
			responseMapping: {
				empNo : 'workEmp',
				empNm : 'workEmpNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			}
		},	
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: PRD3010_R01Filter,
		setEditData: setPRD3010_R01Filter,
		defaultData: defaultPRD3010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PRD3010_R01_search'
	});

	/** 선택된 LOT를 라벨 출력용 LabelPrintData[] 로 변환. LabelPrintButton에 labelDataList로 넘겨 일괄 출력 시 사용 */
	// const selectedLabelDataList = useMemo((): LabelPrintData[] => {
	// 	if (!selectedPRD3010_R01LotList || selectedPRD3010_R01LotList.length === 0 || !PRD3010_R01LotList) return [];

	// 	return selectedPRD3010_R01LotList
	// 		.map((idOrIndex: string) => {
	// 			const lot = PRD3010_R01LotList.find((l: any) => l.id === idOrIndex || String(l.valueIndex) === idOrIndex);
	// 			if (!lot?.lotNo) return null;
	// 			return {
	// 				lotNo: lot.lotNo,
	// 				itemCd: lot.itemCd ?? '',
	// 				itemSpec: lot.itemSpec ?? lot.itemNm ?? '',
	// 				transportDate: '',
	// 				itemAccountNm: '',
	// 				storageLocation: lot.warehouseNm ?? lot.warehouseCd ?? '',
	// 				qty: '',
	// 				customer: '',
	// 				customerItemCd: '',
	// 				labelType: '[생산입고]',
	// 			} as LabelPrintData;
	// 		})
	// 		.filter((x): x is LabelPrintData => x != null);
	// }, [selectedPRD3010_R01LotList, PRD3010_R01LotList]);

	const expandSearch = () => {
		return (
			<>
				<SearchCodeModalForm
					label="품목코드"
					value={PRD3010_R01Filter.itemCd}
					valueLabel={PRD3010_R01Filter.itemNm}
					onChange={getFieldHandlers('itemCd').onChange}
					onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
					onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
					// wrapperOption={{
					// 	wrapperStyle: "w-[500px] min-w-[500px] mr-[10px]",
					// 	titleStyle: "w-[70px] min-w-[70px] text-left",
					// 	codeInputStyle: "w-[200px] min-w-[200px]",
					// 	nameTagStyle: "w-[200px] min-w-[200px] text-left",
					// }}
				/>
				
			
				<SearchCodeModalForm
					label="사용자"
					value={PRD3010_R01Filter.workEmp}
					valueLabel={PRD3010_R01Filter.workEmpNm}
					handleFoucsId={productEmpInfoHandleFoucsId}
					onChange={getFieldHandlers('workEmp').onChange}
					onDoubleClick={getFieldHandlers('workEmp').onDoubleClick} 
					onKeyDown={getFieldHandlers('workEmp').onEnterKeyDown}
				/>
			</>	
		)
	}

    return (
        
        <SearchSectionForm expandSearch={expandSearch}>
			<SearchDropDownForm
				label="사업장"
				value={PRD3010_R01Filter.compCd}
				onChangeItem={(item) => setPRD3010_R01Filter({ compCd: item?.compCd || ''})}
				optionList={compCdList}
			/>
			<SearchDateRangeForm
				label="생산 기간"
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[60px] min-w-[60px]',
				}}
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={PRD3010_R01Filter.dateRange}		setDateRange={(dateRange) => setPRD3010_R01Filter({ dateRange })}
				pickerPosition={pickerPos}
				setPickerPosition={setPickerPos}
			/>
			<SearchDropDownForm
				label="공정유형"
				value={PRD3010_R01Filter.workplaceCd || ''}
				optionList={workPlaceList}
				onChangeItem={(selectedItem) => setPRD3010_R01Filter({ workplaceCd: selectedItem?.workplaceCd || '' })}
			/>
			{/* 저장 시 미출력 LOT 라벨 자동 출력 여부 (Y이면 Content 저장 로직에서 unprintedLabelData 추출 후 printBulkLabel 호출, WMS1020와 동일) */}
			<SearchDropDownForm
				label="Lot라벨자동출력"
				value={PRD3010_R01Filter.labelPrintAuto ?? 'N'}
				onChangeItem={(item) => setPRD3010_R01Filter({ labelPrintAuto: item?.minorCd ?? 'N' })}
				optionList={yesNoList}
				initLabelLess={true}
				wrapperOption={{
					wrapperStyle: "w-[250px] min-w-[250px] mr-[10px]",
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[100px] min-w-[100px]",
					selectStyle: "w-[120px] min-w-[120px] ",
				}}
			/>

			
        </SearchSectionForm>
    );
};
